import { useEffect, useRef } from 'react';

import { useGridPlotSize } from '../../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { reduceExploreCancelTooltip } from '../../../../core/components/interactions-state-helpers/reducers/explore-reducers.js';
import { useSetState } from '../../../hooks/store/selectors.js';

export const useResetOnResize = () => {
  const { width, height } = useGridPlotSize();
  const setState = useSetState();

  //avoid the initial reset, just if chart is already loaded
  const initialLoad = useRef(true);
  useEffect(() => {
    if (initialLoad.current) {
      initialLoad.current = false;
    } else {
      setState(reduceExploreCancelTooltip);
    }
  }, [width, height]);
};
